import { acceptHMRUpdate, defineStore } from 'pinia';
import { computed } from 'vue';

import { useAuthStore } from '~/stores/auth.store';

export const useAuthorizationStore = defineStore('authorization', () => {
	/**
	 * Store used in order to centralize app user authorizations.
	 * Meant to centralize general business logic contextualized by stores (e.g: auth.store, organization.store...)
	 * This should mainly be used by authorization dedicated composables or components across the app
	 */

	/** Imports other stores */
	const authStore = useAuthStore();

	/** Authorization computed */
	const isAdmin = computed<boolean>(() => !!authStore.userProfile?.isAdmin);
	const isAuthenticated = computed(() => authStore.idToken != null);
	const hasBilling = computed<boolean>(() => isAdmin.value && !!authStore.userProfile?.organizationCreatedAt);

	/** Authorization functions */
	const amI = (userId: string): boolean => {
		return authStore.userProfile?.id && userId === authStore.userProfile.id;
	};

	return {
		/** Refs and computed */
		hasBilling,
		isAdmin,
		isAuthenticated,

		/** Authorization functions */
		amI
	};
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(useAuthorizationStore, import.meta.hot));
